(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["js-clips"] && !Shopify.designMode) return;
  try {
    
  class JsClips extends HTMLElement {
    connectedCallback() {
      this.ring = this.querySelector('.js-cl__ring');
      this.stage = this.querySelector('.js-cl__stage');
      this.cards = Array.from(this.querySelectorAll('.js-cl__card'));
      if (!this.ring || !this.cards.length) return;

      this.step = parseFloat(this.dataset.step) || 34;
      this.gap = parseFloat(this.dataset.gap) || 0;
      this.index = 0;
      /* Muted to start, because a browser will refuse unmuted playback without a gesture and
         because a product page that makes noise on its own is a page people leave. Volume is held
         at full behind the mute, so turning sound on is audible straight away rather than needing
         the slider found and dragged as a second step. */
      this.soundOn = false;
      this.volume = 1;

      /* Nothing is downloaded until the visitor brings a clip to the front. video_tag renders a
         poster, so the ring still looks right at rest -- a poster is one image, not a stream. */
      this.videos = this.cards.map((card) => {
        const video = card.querySelector('video');
        if (video) {
          video.preload = 'none';
          video.addEventListener('ended', () => this.setPlaying(card, false));
        }
        return video;
      });

      /* Set only by the viewport observer, so a clip the visitor paused by hand stays paused when
         they scroll back. pauseAll() clears it, which makes every other route to a pause -- the
         toggle, rotating the ring -- read as deliberate without needing to say so at each call. */
      this.pausedByScroll = false;

      this.measure();
      this.bindControls();
      this.watchViewport();
      this.render(false);

      /* Measured again on the next frame. The first call runs before layout has settled and reads
         a card a few pixels narrower than its final width, which quietly shrinks the radius and so
         the gap -- 526px instead of 543px when this was first built. */
      requestAnimationFrame(() => this.measure());

      /* The card, not the stage: its border-box width is what the radius is derived from, and
         ResizeObserver reports layout size, so the 3D transforms do not confuse it. */
      if ('ResizeObserver' in window) {
        new ResizeObserver(() => this.measure()).observe(this.cards[0]);
      }
    }

    /* R = (cardWidth / 2) / tan(step / 2) is the radius at which two neighbouring cards, each
       turned by `step`, sit exactly edge to edge. Widening the span by the gap before dividing
       pushes them that much further apart along the arc, so the gap is a real distance between
       card edges rather than a number that means something different at every card width.

       The radius is measured rather than typed because the right value changes with the rendered
       card width, which changes with the viewport. */
    measure() {
      /* offsetWidth, not getBoundingClientRect: the card sits inside a perspective context, so the
         rect reports its *projected* size and comes back a few pixels short even when the card is
         square-on. That fed a radius of 531px where the card width and gap called for 543px.
         offsetWidth is the layout width and ignores transforms entirely. */
      const width = this.cards[0].offsetWidth;
      if (!width) return;
      const radians = (this.step * Math.PI) / 180;
      const radius = (width + this.gap) / 2 / Math.tan(radians / 2);
      this.style.setProperty('--js-cl-r', Math.round(radius) + 'px');
    }

    bindControls() {
      this.querySelectorAll('.js-cl__arrow').forEach((arrow) => {
        arrow.addEventListener('click', () => this.go(parseInt(arrow.dataset.dir, 10)));
      });

      this.cards.forEach((card, i) => {
        // A side card is a target: click it to bring it round rather than hunting for the arrow.
        card.addEventListener('click', (event) => {
          if (i === this.index) return;
          event.preventDefault();
          this.go(this.shortestWay(i));
        });

        const toggle = card.querySelector('.js-cl__toggle');
        if (toggle) {
          toggle.addEventListener('click', (event) => {
            if (i !== this.index) return;
            event.stopPropagation();
            const video = this.videos[i];
            if (video && video.paused) {
              this.play(i);
            } else {
              this.pauseAll();
            }
          });
        }

        const sound = card.querySelector('.js-cl__sound');
        if (sound) {
          sound.addEventListener('click', (event) => {
            if (i !== this.index) return;
            event.stopPropagation();
            this.setSound(!this.soundOn);
          });
        }

        const volume = card.querySelector('.js-cl__volume');
        if (volume) {
          volume.addEventListener('input', (event) => {
            this.setVolume(event.target.valueAsNumber / 100);
          });
          // Dragging the slider must not also count as clicking the card and rotating the ring.
          ['click', 'pointerdown', 'pointerup'].forEach((type) => {
            volume.addEventListener(type, (event) => event.stopPropagation());
          });
        }
      });

      // Keyboard: the stage is focusable so left/right work without hunting for the arrow buttons.
      this.stage.tabIndex = 0;
      this.stage.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.go(-1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.go(1);
        }
      });

      this.bindDrag();
    }

    /* Dragging turns the ring the way a finger would. Threshold rather than momentum: a ring of
       five clips does not need physics, and a flick that spins past three of them is harder to
       aim than one that moves by one. */
    bindDrag() {
      let startX = null;

      this.stage.addEventListener('pointerdown', (event) => {
        startX = event.clientX;
      });

      this.stage.addEventListener('pointerup', (event) => {
        if (startX === null) return;
        const delta = event.clientX - startX;
        startX = null;
        if (Math.abs(delta) > 40) this.go(delta < 0 ? 1 : -1);
      });

      this.stage.addEventListener('pointercancel', () => {
        startX = null;
      });
    }

    /* On a ring, going from the last card to the first is one step forward, not four back. */
    shortestWay(target) {
      const total = this.cards.length;
      let delta = target - this.index;
      if (delta > total / 2) delta -= total;
      if (delta < -total / 2) delta += total;
      return delta;
    }

    go(delta) {
      if (!delta) return;
      const total = this.cards.length;
      this.index = ((this.index + delta) % total + total) % total;
      this.render(true);
    }

    render(play) {
      const total = this.cards.length;

      this.cards.forEach((card, i) => {
        /* Distance from the front, taking the short way round: on a ring the last card is one step
           from the first, not four. This is the only number the layout needs. */
        let offset = i - this.index;
        if (offset > total / 2) offset -= total;
        if (offset < -total / 2) offset += total;
        const distance = Math.abs(offset);

        /* A card taking the short way round moves more than one step -- it leaves one end of the
           arc and reappears at the other. Animating that sweeps it across the front, through the
           card arriving there.

           On five clips none of this is visible: the wrapping card is always two or more from the
           front, so `is-far` has already taken it to opacity 0. On three clips no card is ever far
           enough to be hidden, so it all happens in full view. Reported on the shower page.

           Snapping alone is not enough, and the first attempt at this fix proved it: the card
           teleports instantly but lands in a slot the outgoing card needs the full 560ms to leave,
           so the two sat stacked with 153px of overlap at 0.72 opacity. That just moved the
           collision from the front of the ring to the side of it.

           So the jump happens while the card is invisible, and it fades in behind the departure.
           The reflow is what forces the browser to commit both the hidden state and the new
           position before the transition comes back -- without it the style writes coalesce and
           the card animates across in full view again. */
        const previous = card.jsClOffset;
        const wrapped = previous !== undefined && Math.abs(offset - previous) > 1;

        if (wrapped) card.classList.add('is-wrapping');
        card.style.setProperty('--i', offset);
        if (wrapped) {
          void card.offsetWidth;
          card.classList.remove('is-wrapping');
          /* Fade in on a delay, then hand the card back to the stylesheet so an ordinary move is
             not slowed down by the arrival timing. */
          card.classList.add('is-arriving');
          window.clearTimeout(card.jsClArrival);
          card.jsClArrival = window.setTimeout(() => card.classList.remove('is-arriving'), 640);
        }
        card.jsClOffset = offset;

        card.classList.toggle('is-active', distance === 0);
        card.classList.toggle('is-adjacent', distance === 1);
        card.classList.toggle('is-far', distance > 1);

        // A hidden card's controls must not be tab stops.
        card.querySelectorAll('.js-cl__btn').forEach((button) => {
          button.tabIndex = distance === 0 ? 0 : -1;
        });
      });

      if (play) {
        this.play(this.index);
      } else {
        this.pauseAll();
      }
    }

    /* One place writes the audio state to the videos and the controls, so the speaker button and
       the slider can never disagree about whether sound is on. */
    applyAudio() {
      this.classList.toggle('is-sound-on', this.soundOn);

      this.videos.forEach((video) => {
        if (!video) return;
        video.muted = !this.soundOn;
        video.volume = this.volume;
      });

      this.querySelectorAll('.js-cl__sound').forEach((button) => {
        button.setAttribute('aria-pressed', this.soundOn ? 'true' : 'false');
        button.setAttribute('aria-label', this.soundOn ? 'Turn sound off' : 'Turn sound on');
      });

      const percent = Math.round(this.volume * 100);
      this.querySelectorAll('.js-cl__volume').forEach((slider) => {
        if (slider.valueAsNumber !== percent) slider.value = percent;
      });
    }

    /* One setting for the whole ring. Turning it on applies to the clip playing now and to every
       clip rotated to afterwards, because someone who turns sound on means "let me hear these". */
    setSound(on) {
      this.soundOn = on;
      // Unmuting while the slider sits at zero is still silence, so bring it back up.
      if (on && this.volume === 0) this.volume = 1;
      this.applyAudio();
    }

    /* The slider and the speaker are the same control seen twice: zero is muted, anything above it
       is not. Dragging to the bottom mutes, dragging up from it unmutes, and the icon follows. */
    setVolume(value) {
      this.volume = value;
      this.soundOn = value > 0;
      this.applyAudio();
    }

    play(index) {
      this.pauseAll();

      const video = this.videos[index];
      const card = this.cards[index];
      if (!video) return;

      video.preload = 'metadata';
      video.muted = !this.soundOn;
      video.volume = this.volume;
      const started = video.play();

      /* A rejected play() is normal -- a browser can refuse before any user gesture, and it refuses
         unmuted playback more readily than muted. Falling back to muted keeps the clip running
         rather than leaving a still frame, and the sound button is corrected so it is not claiming
         sound is on while nothing can be heard. */
      if (started && typeof started.catch === 'function') {
        started.then(() => this.setPlaying(card, true)).catch(() => {
          if (!video.muted) {
            this.setSound(false);
            video.play().then(() => this.setPlaying(card, true)).catch(() => this.setPlaying(card, false));
          } else {
            this.setPlaying(card, false);
          }
        });
      } else {
        this.setPlaying(card, true);
      }
    }

    /* A clip that keeps running after it has scrolled off is the worst version of this section: the
       visitor turned sound on deliberately, then walks down the rest of the page with a video
       talking at them from somewhere above. So playback follows the ring on screen.

       Measured against a viewport shrunk 20% top and bottom rather than a ratio of the stage. A
       ratio threshold depends on the stage fitting inside the viewport, which it does not on a short
       phone in landscape -- the ratio then never reaches the threshold and the clip never pauses.
       The inset band is independent of how tall the stage is.

       Resume is deliberately narrow: only a clip this observer paused starts again. Anything the
       visitor stopped by hand, or by rotating the ring, stays stopped. */
    watchViewport() {
      if (!('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (this.pausedByScroll) this.play(this.index);
            } else {
              const video = this.videos[this.index];
              const wasPlaying = video && !video.paused;
              this.pauseAll();
              this.pausedByScroll = wasPlaying;
            }
          });
        },
        { threshold: 0, rootMargin: '-20% 0px -20% 0px' }
      );

      observer.observe(this.stage);
    }

    pauseAll() {
      // Any pause that is not the observer's own is the visitor's, so nothing should resume later.
      this.pausedByScroll = false;

      this.videos.forEach((video, i) => {
        if (video && !video.paused) video.pause();
        this.setPlaying(this.cards[i], false);
      });
    }

    setPlaying(card, playing) {
      card.classList.toggle('is-playing', playing);
      const toggle = card.querySelector('.js-cl__toggle');
      if (toggle) toggle.setAttribute('aria-label', playing ? 'Pause clip' : 'Play clip');
    }
  }

  if (!customElements.get('js-clips')) {
    customElements.define('js-clips', JsClips);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["js-faq"] && !Shopify.designMode) return;
  try {
    
  /*
   * Same <details> approach as js-accordions: held permanently open so content stays in layout
   * and is therefore measurable, visual state driven by .is-open, padding on an inner wrapper,
   * animated with the Web Animations API so a mid-flight click cancels cleanly.
   *
   * Duplicated rather than shared on purpose -- each file in this build stands alone.
   */
  class JsFaqList extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.js-faq__item'));
      if (!this.items.length) return;

      this.filters = Array.from(this.querySelectorAll('.js-faq__filter'));
      this.emptyMessage = this.querySelector('.js-faq__empty');
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.items.forEach((item) => {
        this.apply(item, false, false);
        item.querySelector('.js-faq__summary').addEventListener('click', (event) => {
          event.preventDefault();
          this.toggle(item);
        });
      });

      this.filters.forEach((button) => {
        button.addEventListener('click', () => this.filter(button));
      });
    }

    filter(button) {
      const value = button.dataset.filter;

      this.filters.forEach((other) => {
        const active = other === button;
        other.classList.toggle('is-active', active);
        other.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      let visible = 0;
      this.items.forEach((item) => {
        const show = value === 'all' || item.dataset.category === value;
        item.hidden = !show;
        if (show) visible += 1;
        // Collapse anything being hidden so it does not reopen mid-height when filtered back in.
        if (!show && item.classList.contains('is-open')) this.apply(item, false, false);
      });

      if (this.emptyMessage) this.emptyMessage.hidden = visible > 0;
    }

    toggle(item) {
      const willOpen = !item.classList.contains('is-open');
      if (willOpen) {
        this.items.forEach((other) => {
          if (other !== item) this.apply(other, false, true);
        });
      }
      this.apply(item, willOpen, true);
    }

    apply(item, open, animate) {
      const panel = item.querySelector('.js-faq__panel');
      const inner = item.querySelector('.js-faq__answer');
      const summary = item.querySelector('.js-faq__summary');

      if (item.animation) {
        item.animation.cancel();
        item.animation = null;
      }

      item.classList.toggle('is-open', open);
      summary.setAttribute('aria-expanded', open ? 'true' : 'false');

      if (!animate || this.reduceMotion) {
        panel.style.height = open ? 'auto' : '0px';
        return;
      }

      const start = panel.getBoundingClientRect().height;
      const end = open ? inner.getBoundingClientRect().height : 0;

      if (start === end) {
        panel.style.height = open ? 'auto' : '0px';
        return;
      }

      panel.style.height = start + 'px';

      const animation = panel.animate(
        [{ height: start + 'px' }, { height: end + 'px' }],
        { duration: 300, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
      );

      item.animation = animation;

      animation.onfinish = () => {
        panel.style.height = open ? 'auto' : '0px';
        item.animation = null;
      };
    }
  }

  if (!customElements.get('js-faq-list')) {
    customElements.define('js-faq-list', JsFaqList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["js-feature-cards"] && !Shopify.designMode) return;
  try {
    
  /* A custom element rather than a querySelectorAll pass, so a card added in the theme editor
     wires itself up without a reload -- the same reason the other js- components are elements.

     Autoplay is off unless the template asks for it with data-autoplay, and even then it only
     runs while the clip is actually on screen. Muted video that plays through a page nobody
     scrolled to costs a South African visitor data they did not agree to spend, which is the rule
     js-clips follows. Playing only in view keeps that promise while still letting a short product
     spin do its job, and pausing on the way out means the cost is bounded by what was watched. */
  class JsZzVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('.js-zz__play');
      if (!this.video || !this.button) return;

      this.button.addEventListener('click', () => {
        this.paused = !this.video.paused;
        // A pause the visitor asked for outranks the observer, so it must not resume on scroll back.
        this.pausedByScroll = false;
        if (this.video.paused) {
          this.video.play();
        } else {
          this.video.pause();
        }
      });

      /* Watched whether or not the template autoplays. Autoplay decides whether a clip STARTS on its
         own; leaving the viewport should stop a clip either way, or a video the visitor pressed play
         on carries on talking from off screen while they read the rest of the page. */
      this.watch();

      /* Driven by the video's own events, not by the click, so the label stays honest if playback
         is stopped by anything else -- the end of a clip, or the browser reclaiming it. */
      ['play', 'pause', 'ended'].forEach((event) => {
        this.video.addEventListener(event, () => this.sync());
      });

      this.sync();
    }

    /* Someone who reduces motion has asked not to be shown things that move on their own. The
       button still works, so the clip is available -- it just does not start by itself. */
    watch() {
      if (!('IntersectionObserver' in window)) return;

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const autoplay = this.hasAttribute('data-autoplay');

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              /* Two different reasons to start, and only one of them is automatic. Resuming a clip
                 this observer paused is finishing what the visitor started, so it is allowed even
                 for someone who reduces motion -- unlike autoplay, which is not.

                 A play() the browser refuses -- a policy some versions of Safari apply before the
                 element is known to be muted -- rejects rather than throwing, and an unhandled
                 rejection would surface in the console on every scroll. */
              if (this.pausedByScroll || (autoplay && !reduced && !this.paused)) {
                this.video.play().catch(() => {});
              }
              this.pausedByScroll = false;
            } else if (!this.video.paused) {
              this.pausedByScroll = true;
              this.video.pause();
            }
          });
        },
        { threshold: 0.5 }
      );

      observer.observe(this);
    }

    sync() {
      const playing = !this.video.paused && !this.video.ended;
      this.classList.toggle('is-playing', playing);
      this.button.setAttribute('aria-label', playing ? 'Pause' : 'Play');
    }
  }

  if (!customElements.get('js-zz-video')) {
    customElements.define('js-zz-video', JsZzVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["js-goes-with"] && !Shopify.designMode) return;
  try {
    
  /* Adds independently of the product form, for the same reason js-product-addons does: the
     theme's form runs two different submit modes and the primary Add to Cart must not be put
     at risk by a cross-sell. */
  (function () {
    document.addEventListener('click', function (event) {
      /* button, not .js-gw__button: multi-variant cards render an anchor wearing the same class,
         and that one must be left alone to navigate to the product page. */
      const button = event.target.closest('button.js-gw__button');
      if (!button) return;

      const root = button.closest('.js-gw');
      const errorEl = root ? root.parentElement.querySelector('.js-gw__error') : null;
      const id = button.dataset.variantId;
      if (!id) return;

      button.setAttribute('aria-busy', 'true');
      if (errorEl) errorEl.hidden = true;

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(id), quantity: 1 }],
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname
        })
      })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description || data.message);

          /* Hand the response to Dawn's own renderContents rather than swapping the section HTML
             by hand. Swapping by hand looked right and did nothing at all: the drawer is rendered
             from layout/theme.liquid as a snippet, so no #shopify-section-cart-drawer wrapper
             exists to swap into. The add succeeded, the drawer kept its empty markup, and the
             customer saw an empty cart until they reloaded. renderContents writes into #CartDrawer,
             refreshes the count bubble, and opens the drawer. */
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.renderContents(data);

            /* renderContents clears is-empty from .drawer__inner but not from the element, and the
               CSS hangs off the element: cart-drawer.is-empty hides .drawer__header and
               .drawer__footer outright. Dawn's own product-form.js does this same removal. */
            if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          } else if (data.sections) {
            /* Cart type set to notification or page instead of drawer — there is no cart-drawer
               element to render into, so refresh whatever section wrappers the page does have. */
            Object.keys(data.sections).forEach(function (key) {
              const target =
                document.getElementById(key) || document.querySelector('#shopify-section-' + key);
              if (!target) return;
              const parsed = new DOMParser().parseFromString(data.sections[key], 'text/html');
              const source =
                parsed.getElementById(key) || parsed.querySelector('#shopify-section-' + key);
              if (source) target.innerHTML = source.innerHTML;
            });
          }

          button.classList.add('is-added');
          button.textContent = button.dataset.addedLabel;
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch(function (error) {
          if (errorEl) {
            errorEl.textContent = error.message || 'Could not add that. Please try again.';
            errorEl.hidden = false;
          }
        })
        .finally(function () {
          button.removeAttribute('aria-busy');
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["js-logo-marquee"] && !Shopify.designMode) return;
  try {
    
  // Duration comes from measured width so the band drifts at one speed whatever it holds -- a
  // fixed duration would sprint with three logos and crawl with twelve.
  (function () {
    function tune(track) {
      var sets = track.querySelectorAll('.js-lm__set');
      if (!sets.length) return;

      var speed = parseFloat(track.dataset.speed) || 45;
      // The animation slides exactly half the track, so that half is the distance travelled.
      var distance = track.scrollWidth / 2;
      if (!distance) return;

      track.style.setProperty('--js-lm-duration', distance / speed + 's');
    }

    function init() {
      document.querySelectorAll('.js-lm__track').forEach(function (track) {
        tune(track);

        // Logos are lazy-loaded, so the first measurement can land before they have width.
        if ('ResizeObserver' in window) {
          var ro = new ResizeObserver(function () {
            tune(track);
          });
          ro.observe(track);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["js-scratch-offer"] && !Shopify.designMode) return;
  try {
    
  class JsScratchOffer extends HTMLElement {
    connectedCallback() {
      const dataEl = this.querySelector('.js-so__data');
      try {
        this.prizes = JSON.parse(dataEl.textContent).filter((p) => p.code);
      } catch (e) {
        this.prizes = [];
      }
      if (!this.prizes.length) return;

      this.host = window.location.host;
      this.keyDismiss = 'js-so-dismissed-' + this.host;
      this.keyPrize = 'js-so-prize-' + this.host;
      this.keyClaim = 'js-so-claiming-' + this.host;
      this.keyDone = 'js-so-done-' + this.host;

      /* Rendered by Liquid only when the customer form actually posted successfully. Measured on
         this store: the URL carries no marker either way, with or without return_to, so this is the
         only trustworthy signal. */
      this.posted = !!this.querySelector('.js-so__posted');
      this.postError = this.querySelector('.js-so__posted-error');
      this.resuming = this.posted || !!this.postError;

      /* Test mode forgets everything on every load: no dismissal, no locked prize. That is the whole
         point -- the live behaviour deliberately shows one prize once and then hides for ten days,
         which makes it almost impossible to check your own work. */
      this.testing = this.dataset.mode !== 'live';
      // Not while resuming a signup: the stored prize is the only record of what they won.
      if (this.testing && !this.resuming) {
        try {
          localStorage.removeItem(this.keyDismiss);
          localStorage.removeItem(this.keyPrize);
          localStorage.removeItem(this.keyDone);
        } catch (e) {
          /* storage refused; nothing was remembered anyway */
        }
      }

      this.tab = this.querySelector('.js-so__tab');
      this.tabClose = this.querySelector('.js-so__tab-close');
      this.overlay = this.querySelector('.js-so__overlay');
      this.modal = this.querySelector('.js-so__modal');
      this.card = this.querySelector('.js-so__card');
      this.canvas = this.querySelector('.js-so__foil');
      this.prizeLabel = this.querySelector('.js-so__prize-label');
      this.form = this.querySelector('.js-so__form');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.isDismissed()) {
        this.classList.add('js-so--gone');
      }

      this.restorePrize();
      // After restorePrize: the record is only trusted if the prize it names still exists.
      this.restoreDone();
      this.bind();
      this.watchDrawers();

      this.resumeAfterSignup();

      // Opens itself only in the loudest test mode, never live -- and never over a resumed claim.
      if (this.dataset.mode === 'test_open' && !this.resuming) {
        setTimeout(() => this.open(), 800);
      }
    }

    /* --- persistence ------------------------------------------------------------------------ */

    isDismissed() {
      try {
        const raw = localStorage.getItem(this.keyDismiss);
        if (!raw) return false;
        return new Date(JSON.parse(raw).until) > new Date();
      } catch (e) {
        return false;
      }
    }

    dismiss() {
      const days = parseInt(this.dataset.days, 10) || 10;
      const until = new Date(Date.now() + days * 86400000).toISOString();
      try {
        localStorage.setItem(this.keyDismiss, JSON.stringify({ until: until }));
      } catch (e) {
        /* Private browsing can refuse storage. The tab simply returns next visit. */
      }
      this.classList.add('js-so--gone');
      this.close();
    }

    /* The draw is remembered so re-opening cannot re-roll it -- without that the odds mean nothing,
       because anyone can keep scratching until the best prize turns up.

       It expires on the same clock as the dismissal, so a visitor can play again once that period
       has passed rather than being stuck on one result forever. That does let a patient person
       re-roll, which is accepted: the offer is open to everyone every 10 days by design. */
    restorePrize() {
      try {
        const raw = localStorage.getItem(this.keyPrize);
        if (!raw) return;
        const saved = JSON.parse(raw);
        if (saved.until && new Date(saved.until) <= new Date()) {
          localStorage.removeItem(this.keyPrize);
          return;
        }
        const match = this.prizes.find((p) => p.code === saved.code);
        // A prize removed or re-coded in the theme editor should not strand anyone on a dead code.
        if (match) this.prize = match;
      } catch (e) {
        /* no stored prize */
      }
    }

    /* --- the completed state ----------------------------------------------------------------

       Someone who has scratched, signed up and been given a code should not still be invited to
       "Try your luck". Re-opening cannot re-roll -- restorePrize pins the draw -- so this is not an
       abuse hole, but the tab reads as a fresh offer for something they have already claimed, and
       taking a second run at it means re-scratching a foil and re-entering an address for no gain.

       The tab is kept rather than hidden because **no prize is emailed** -- every block is
       deliver_by: show, so the modal is the only place the code exists. Hiding the tab would strand
       anyone who closed it without copying. Instead it relabels and reopens straight on the code. */

    /* Recorded only once the code is actually in their hands, so an abandoned half-flow -- scratched
       but never submitted -- still shows the normal offer.

       Shares the prize's expiry deliberately: when the prize is allowed to be drawn again the tab
       goes back to inviting a fresh play on the same clock, with no second timer to drift. */
    markDone() {
      if (!this.prize) return;
      try {
        const days = parseInt(this.dataset.days, 10) || 10;
        localStorage.setItem(this.keyDone, JSON.stringify({
          code: this.prize.code,
          until: new Date(Date.now() + days * 86400000).toISOString()
        }));
      } catch (e) {
        /* storage refused; the tab simply keeps its original label */
      }
      this.applyDoneTab();
    }

    restoreDone() {
      try {
        const raw = localStorage.getItem(this.keyDone);
        if (!raw) return;
        const saved = JSON.parse(raw);
        if (saved.until && new Date(saved.until) <= new Date()) {
          localStorage.removeItem(this.keyDone);
          return;
        }
        /* The prize must still exist and still match. One renamed or removed in the theme editor
           would otherwise leave the tab promising a code this section can no longer show -- the
           same trap restorePrize guards against. */
        if (!this.prize || this.prize.code !== saved.code) {
          localStorage.removeItem(this.keyDone);
          return;
        }
        this.applyDoneTab();
      } catch (e) {
        /* nothing recorded */
      }
    }

    /* Text only -- no colour or size change. A restyled tab pulls the eye back to something they
       have finished with, which is the opposite of the point. */
    applyDoneTab() {
      this.done = true;
      const text = this.querySelector('.js-so__tab-text');
      const label = this.dataset.tabLabelDone;
      if (text && label) text.textContent = label;
    }

    /* Weighted draw. Each prize's weight is its share of the total, so the numbers are relative and
       need not add up to anything in particular. */
    draw() {
      if (this.prize) return this.prize;

      const total = this.prizes.reduce((sum, p) => sum + (Number(p.weight) || 0), 0);
      let roll = Math.random() * (total || this.prizes.length);

      this.prize = this.prizes[this.prizes.length - 1];
      for (const prize of this.prizes) {
        roll -= Number(prize.weight) || 0;
        if (roll <= 0) {
          this.prize = prize;
          break;
        }
      }

      try {
        /* The expiry has to be written here, not only read in restorePrize -- without it the stored
           record has no `until`, the expiry check is skipped, and the prize locks forever. */
        const days = parseInt(this.dataset.days, 10) || 10;
        localStorage.setItem(this.keyPrize, JSON.stringify({
          code: this.prize.code,
          until: new Date(Date.now() + days * 86400000).toISOString()
        }));
      } catch (e) {
        /* storage refused; the prize just will not survive a reload */
      }

      return this.prize;
    }

    /* --- wiring ----------------------------------------------------------------------------- */

    bind() {
      this.tab.addEventListener('click', () => this.openTab());
      this.tabClose.addEventListener('click', () => this.dismiss());
      this.querySelector('.js-so__close').addEventListener('click', () => this.close());
      this.querySelector('.js-so__decline').addEventListener('click', () => this.close());
      this.querySelector('.js-so__done').addEventListener('click', () => this.close());
      this.querySelector('.js-so__reveal').addEventListener('click', () => this.reveal());
      this.querySelector('.js-so__claim').addEventListener('click', () => this.step('email'));
      this.querySelector('.js-so__copy').addEventListener('click', () => this.copy());

      this.overlay.addEventListener('click', (event) => {
        if (event.target === this.overlay) this.close();
      });

      this.addEventListener('keydown', (event) => {
        if (this.overlay.hidden) return;
        if (event.key === 'Escape') this.close();
        if (event.key === 'Tab') this.trapFocus(event);
      });

      // Anything anywhere can open this -- the footer uses it instead of its own form.
      document.addEventListener('click', (event) => {
        if (event.target.closest('[data-js-so-open]')) {
          event.preventDefault();
          this.open();
        }
      });

      this.form.addEventListener('submit', (event) => this.submit(event));
      this.setupScratch();
    }

    /* Dawn locks the body with overflow-hidden while the cart, the menu or the mobile filter is
       open. The tab stands down for the same reasons the WhatsApp button does. */
    watchDrawers() {
      const apply = () => {
        this.classList.toggle('js-so--away', /(^|\s)overflow-hidden/.test(document.body.className));
      };
      apply();
      if ('MutationObserver' in window) {
        new MutationObserver(apply).observe(document.body, { attributes: true, attributeFilter: ['class'] });
      }
    }

    /* --- modal ------------------------------------------------------------------------------ */

    /* The tab's own click. A visitor who has already claimed is coming back for the code they won,
       not for another go, so send them straight to it -- same path resumeAfterSignup uses, so there
       is only ever one way the code step gets shown.

       Only the tab does this. Anything else that opens the offer (the footer's [data-js-so-open])
       still calls open() directly and behaves as before. */
    openTab() {
      if (this.done && this.prize) {
        this.classList.add('js-so--revealed');
        this.writePrize();
        this.open({ keepPrize: true });
        this.showCode();
        return;
      }
      this.open();
    }

    open(options) {
      /* In test mode every open is a clean card: the drawn prize, the scratched foil and the step
         are all thrown away. Without this, reopening shows the same revealed prize and there is no
         way to see a second outcome without reloading the page.

         Except when resuming a signup -- throwing the prize away there would lose the thing they
         just gave their address for. */
      if (this.testing && !(options && options.keepPrize)) {
        this.prize = null;
        this.classList.remove('js-so--revealed');
        this.modal.classList.remove('is-by-email');
        this.modal.dataset.step = 'scratch';
        const field = this.querySelector('.js-so__code');
        if (field) field.value = '';
      }

      this.overlay.hidden = false;
      this.lastFocus = document.activeElement;
      this.step(this.modal.dataset.step || 'scratch');
      // The canvas has no size until it is displayed, so it can only be painted -- and a prize
      // already written can only be fitted -- now.
      requestAnimationFrame(() => {
        this.paintFoil();
        this.fitPrize();
      });
      /* Focus the action, not the close button. A comma list in querySelector returns whichever
         comes first in the DOM, and the close button does -- so this picks deliberately. */
      const step = this.modal.dataset.step;
      const wanted = step === 'scratch'
        ? (this.classList.contains('js-so--revealed') ? '.js-so__claim' : '.js-so__reveal')
        : step === 'email' ? '.js-so__input' : '.js-so__copy';
      const focusTarget = this.modal.querySelector(wanted) || this.modal.querySelector('.js-so__close');
      if (focusTarget) focusTarget.focus();
    }

    close() {
      this.overlay.hidden = true;
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    }

    step(name) {
      this.modal.dataset.step = name;
    }

    trapFocus(event) {
      const focusable = this.modal.querySelectorAll(
        'button:not([hidden]), input:not([type="hidden"]), [href], [tabindex]:not([tabindex="-1"])'
      );
      const visible = Array.from(focusable).filter((el) => el.offsetParent !== null);
      if (!visible.length) return;

      const first = visible[0];
      const last = visible[visible.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    /* --- the scratch card ------------------------------------------------------------------- */

    paintFoil() {
      const rect = this.card.getBoundingClientRect();
      if (!rect.width) return;

      const dpr = window.devicePixelRatio || 1;
      this.canvas.width = Math.round(rect.width * dpr);
      this.canvas.height = Math.round(rect.height * dpr);

      const ctx = this.canvas.getContext('2d');
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.globalCompositeOperation = 'source-over';
      ctx.clearRect(0, 0, rect.width, rect.height);

      // Sunset Gold with a diagonal sheen -- the one decorative thing in the whole component.
      const foil = getComputedStyle(this).getPropertyValue('--js-so-foil').trim() || '#f4b860';
      const sheen = ctx.createLinearGradient(0, 0, rect.width, rect.height);
      sheen.addColorStop(0, foil);
      sheen.addColorStop(0.45, '#fbe3b8');
      sheen.addColorStop(0.55, '#fff6e6');
      sheen.addColorStop(1, foil);
      ctx.fillStyle = sheen;
      ctx.fillRect(0, 0, rect.width, rect.height);

      ctx.fillStyle = 'rgba(122, 58, 32, 0.42)';
      ctx.font = '600 ' + Math.round(rect.width / 14) + 'px ' +
        (getComputedStyle(this).getPropertyValue('--font-body-family') || 'sans-serif');
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(this.dataset.scratchHint || 'Scratch here', rect.width / 2, rect.height / 2);

      ctx.globalCompositeOperation = 'destination-out';

      /* Opaque, and it must be set explicitly. fillStyle is still the translucent brown used for the
         hint text above, and under destination-out the fill's alpha is how much it erases -- so
         scratching rubbed at 42% strength and never actually cleared anything. */
      ctx.fillStyle = 'rgba(0, 0, 0, 1)';

      this.cardRect = rect;
      this.scratched = false;
    }

    setupScratch() {
      let drawing = false;
      let moves = 0;

      const at = (event) => {
        const rect = this.canvas.getBoundingClientRect();
        return { x: event.clientX - rect.left, y: event.clientY - rect.top };
      };

      const scrub = (event) => {
        if (!drawing || this.classList.contains('js-so--revealed')) return;
        const point = at(event);
        const ctx = this.canvas.getContext('2d');
        ctx.beginPath();
        ctx.arc(point.x, point.y, Math.max(18, this.canvas.clientWidth / 12), 0, Math.PI * 2);
        ctx.fill();

        // getImageData is expensive, so progress is sampled rather than measured every move.
        moves += 1;
        if (moves % 8 === 0 && this.clearedEnough()) this.reveal();
      };

      this.canvas.addEventListener('pointerdown', (event) => {
        drawing = true;
        this.canvas.setPointerCapture(event.pointerId);
        this.draw();
        this.writePrize();
        scrub(event);
      });
      this.canvas.addEventListener('pointermove', scrub);
      this.canvas.addEventListener('pointerup', () => {
        drawing = false;
      });
      this.canvas.addEventListener('pointercancel', () => {
        drawing = false;
      });
    }

    /* Sampled on a grid rather than pixel by pixel -- one read of a few hundred points is enough to
       know when roughly half the foil is gone, and cheap enough to run mid-drag. */
    clearedEnough() {
      const ctx = this.canvas.getContext('2d');
      const w = this.canvas.width;
      const h = this.canvas.height;
      let clear = 0;
      let total = 0;

      try {
        const data = ctx.getImageData(0, 0, w, h).data;
        const stepX = Math.max(1, Math.floor(w / 24));
        const stepY = Math.max(1, Math.floor(h / 24));
        for (let y = 0; y < h; y += stepY) {
          for (let x = 0; x < w; x += stepX) {
            total += 1;
            if (data[(y * w + x) * 4 + 3] < 32) clear += 1;
          }
        }
      } catch (e) {
        return false;
      }

      const threshold = (parseInt(this.dataset.revealAt, 10) || 60) / 100;
      return total > 0 && clear / total >= threshold;
    }

    writePrize() {
      const prize = this.draw();
      this.prizeLabel.textContent = prize.label;

      // Joined with an explicit space: a trailing space in a setting does not survive the round trip
      // through the HTML attribute, so relying on the merchant to type one produces "prize:10% off".
      const line = (this.dataset.wonLine || 'Your prize:').trim();
      this.querySelectorAll('.js-so__sub--won, .js-so__sub--won2').forEach((el) => {
        el.textContent = line + ' ' + prize.label;
      });

      // The condition travels with the prize to under the card and onto the code step.
      const terms = (prize.terms || '').trim();
      const onCard = this.querySelector('.js-so__card-terms');
      const onCode = this.querySelector('.js-so__terms-note');
      if (onCard) onCard.textContent = terms;
      if (onCode) onCode.textContent = terms;

      this.fitPrize();

      const tags = this.form.querySelector('input[name="contact[tags]"]');
      if (tags && prize.handle) {
        tags.value = 'newsletter, scratch-offer, won-' + prize.handle;
      }
    }

    /* The card cannot grow to fit its prize: the foil is painted to the card's size when it opens,
       and the prize is written underneath afterwards, on the first scratch. So a long prize name
       steps its own size down until the card holds it. "A free multi-tool" runs to two lines and
       overflowed a 360px phone's card; "10% off" and "A free flask" keep the full size.

       Measured, not keyed on character count, so a prize renamed in the theme editor fits too. A
       hidden card measures 0 and is left alone; open() runs this again once it is on screen.

       The test is the lines' own extent against the padded inner area, not scrollHeight: the
       content is centred, and Chrome leaves the end padding out of a flex box's scrollHeight, so an
       overflow smaller than the padding read as fitting and the last line sat on the inset border. */
    fitPrize() {
      const box = this.querySelector('.js-so__prize');
      const label = this.prizeLabel;
      if (!box || !label || !label.textContent || !box.clientHeight) return;

      const style = getComputedStyle(box);
      const room = box.clientHeight - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom);
      const used = () => {
        // getBoundingClientRect, not offsetHeight: the chevron mark is an SVG, which has none.
        const lines = Array.from(box.children).filter((el) => el.getBoundingClientRect().height);
        if (!lines.length) return 0;
        return lines[lines.length - 1].getBoundingClientRect().bottom - lines[0].getBoundingClientRect().top;
      };

      label.style.fontSize = '';
      let size = parseFloat(getComputedStyle(label).fontSize);
      while (used() > room && size > 18) {
        size -= 2;
        label.style.fontSize = size + 'px';
      }
    }

    reveal() {
      this.draw();
      this.writePrize();
      this.classList.add('js-so--revealed');
      if (this.reduced) this.canvas.style.transition = 'none';
      const claim = this.querySelector('.js-so__claim');
      if (claim) claim.focus();
    }

    /* --- the part the old pop-up got wrong -------------------------------------------------- */

    /* The form posts natively. It must.

       Shopify attaches an invisible spam-protection token to customer forms, and it is only
       attached on a real submission. Sending the same fields with fetch loses it, and every request
       comes back 400 "Missing CAPTCHA token" -- which is what an earlier version of this did, and
       why it failed for every visitor. The only alternative is turning spam protection off, which
       trades a working form for a bot-filled customer list.

       So the page navigates, Shopify appends customer_posted=true to return_to, and
       resumeAfterSignup picks the flow back up on the way in. The prize is already in localStorage,
       so nothing has to be carried through the URL. */
    submit(event) {
      const error = this.querySelector('.js-so__error');
      const email = this.form.querySelector('input[type="email"]');

      if (!email.value || !email.checkValidity()) {
        event.preventDefault();
        error.textContent = 'Please enter a valid email address.';
        error.hidden = false;
        email.focus();
        return;
      }

      try {
        localStorage.setItem(this.keyClaim, '1');
      } catch (e) {
        /* storage refused; they will land back on the page without the code reopening */
      }

      /* Nothing is disabled here, deliberately.

         Shopify's spam protection is hCaptcha, and it does not let this submit through. It cancels
         it, injects a challenge, and re-submits the form itself once the challenge is solved.
         Disabling the button on the first click leaves that second submission pushing against a
         dead control -- the challenge is solved, the page appears to reload, and nothing happens.
         Which is exactly what it did.

         So: record the claim, then stay out of hCaptcha's way. */
      // No preventDefault: this is the submission hCaptcha will pick up and carry.
    }

    /* Coming back from the signup. Reopen at the code step rather than making them scratch again. */
    resumeAfterSignup() {
      if (!this.resuming) return;

      let claiming = false;
      try {
        claiming = localStorage.getItem(this.keyClaim) === '1';
        localStorage.removeItem(this.keyClaim);
      } catch (e) {
        /* no storage, no resume */
      }
      if (!claiming) return;

      // Shopify rejected it -- reopen on the form with the reason rather than silently doing nothing.
      if (this.postError) {
        const error = this.querySelector('.js-so__error');
        if (error) {
          error.textContent = this.postError.textContent.trim() || 'That address was not accepted.';
          error.hidden = false;
        }
        this.open({ keepPrize: true });
        this.step('email');
        return;
      }

      // Storage lost the prize, so there is nothing honest to show. Leave them on a fresh card.
      if (!this.prize) return;

      this.classList.add('js-so--revealed');
      this.writePrize();
      this.open({ keepPrize: true });
      this.showCode();
      /* The one unambiguous completion point: the signup posted and the code is on screen. Marked
         here rather than inside showCode, which openTab also calls -- that would re-stamp the
         expiry every time they came back to look, and the tab would never return to the offer. */
      this.markDone();
    }

    showCode() {
      const prize = this.draw();
      const byEmail = prize.byEmail === true;

      this.modal.classList.toggle('is-by-email', byEmail);

      const heading = this.querySelector('.js-so__title--code');
      if (heading) {
        heading.textContent = byEmail
          ? (this.dataset.emailCodeHeading || 'On its way')
          : (this.dataset.codeHeading || heading.textContent);
      }

      if (!byEmail) this.querySelector('.js-so__code').value = prize.code;

      this.step('code');

      // Nothing to copy on an email prize, so focus what they can actually act on.
      const target = byEmail ? this.querySelector('.js-so__done') : this.querySelector('.js-so__copy');
      if (target) target.focus();
    }

    async copy() {
      const field = this.querySelector('.js-so__code');
      const note = this.querySelector('.js-so__copied');

      try {
        await navigator.clipboard.writeText(field.value);
      } catch (e) {
        // Clipboard access is refused in plenty of contexts; selecting the text still lets them copy.
        field.select();
        field.setSelectionRange(0, 99);
      }

      note.hidden = false;
      setTimeout(() => {
        note.hidden = true;
      }, 3000);
    }
  }

  if (!customElements.get('js-scratch-offer')) {
    customElements.define('js-scratch-offer', JsScratchOffer);
  }

  } catch(e) { console.error(e); }
})();
})();
